<form [formGroup]="efilingSettingForm">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-4">
        <label class="create-task-label required">Petition Preparing</label>
        <div class="p-formgroup-inline">
          <div class="p-field-checkbox">
            <p-radioButton name="filingType" value="standard" formControlName="filingType"
              inputId="standard"></p-radioButton>
            <label for="standard" class="create-task-label">Standard</label>
          </div>
          <div class="p-field-checkbox">
            <p-radioButton name="filingType" value="e-filing" formControlName="filingType"
              inputId="e-filing"></p-radioButton>
            <label for="e-filing" class="create-task-label">E-filing</label>
          </div>
        </div>
      </div>
    </div>
    <p-divider type="dashed" class="d-block"></p-divider>
    <div class="row py-2">
      <div class="col-md-2 p-0">
        <button pButton type="submit" label="Save" title="Save" class="save-btn" icon="pi pi-save" (click)="handleSaveSetting()"
          ></button>
      </div>
      <div class="col-md-2">
        <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left
            d-flex alogn-items-center"  (click)="handleCancel()">
        </button>
      </div>
      </div>
   
</form>